import { FormEvent, useState } from 'react';
import { useForgotPasswordMutation } from 'app/services';
import { useBodyClass } from 'hooks/useBodyClass';
import { useDocumentTitle } from 'hooks/useDocumentTitle';

// Faithful re-implementation of forgot_password.html.
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [forgotPassword] = useForgotPasswordMutation();
  useBodyClass('sign-in');
  useDocumentTitle('Kinetix - Forgot Password');

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await forgotPassword({ email }).unwrap();
    } finally {
      setSubmitted(true); // generic confirmation regardless of outcome
    }
  };

  return (
    <div className="sign-in-container">
      <div className="login">
        <div className="login-logo" />
        <div className="form-info">
          <h4 className="form-name">Forgot Password</h4>
        </div>
          {submitted ? (
            <p style={{ lineHeight: 1.6 }}>
              If an account exists for that email, we've sent a link to reset your password. The link
              is valid for 1 hour.
            </p>
          ) : (
            <form id="forgot-password-form" method="post" action="/forgot-password/" onSubmit={onSubmit}>
              <p style={{ lineHeight: 1.6, marginBottom: 20 }}>
                Enter the email address associated with your account and we'll send you a link to
                reset your password.
              </p>
              <div className="first-input">
                <input
                  id="email"
                  type="email"
                  name="email"
                  className="form-field"
                  placeholder="Email"
                  required
                  style={{ width: '80%', boxSizing: 'border-box' }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="button">
                <input type="submit" value="Send Reset Link" />
              </div>
            </form>
          )}
        </div>
      </div>
  );
};

export default ForgotPassword;
